import { defineStore } from 'pinia';
let confirmResolver: ((answer: boolean) => void) | null = null;
export const useUiStore = defineStore('ui', {
  state: () => ({ loading: 0, toast: '', toastType: 'default' as 'default' | 'success', toastTimer: 0, preview: [] as string[], previewIndex: 0, confirmMessage: '' }),
  actions: {
    begin() { this.loading += 1; }, end() { this.loading = Math.max(0, this.loading - 1); },
    show(message: string, type: 'default' | 'success' = 'default') { this.toast = message; this.toastType = type; window.clearTimeout(this.toastTimer); this.toastTimer = window.setTimeout(() => { this.toast = ''; }, type === 'success' ? 1200 : 2400); },
    previewImages(urls: string[], index = 0) { this.preview = urls; this.previewIndex = index; }, closePreview() { this.preview = []; },
    confirm(message: string) { this.confirmMessage = message; return new Promise<boolean>((resolve) => { confirmResolver = resolve; }); },
    answer(answer: boolean) { this.confirmMessage = ''; confirmResolver?.(answer); confirmResolver = null; },
  },
});
